"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningBox = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
require("./RepositoryOwnerPanel.scss");
var _ExternalLink = require("../Shared/Components/ExternalLink");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var WarningBox = function WarningBox() {
  return /*#__PURE__*/React.createElement(_react2.MessageBar, {
    messageBarType: _react2.MessageBarType.severeWarning
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-box-first-section"
  }, t("repositoryOwnerPanel.warning.doNotRequestExemption"), /*#__PURE__*/React.createElement(_ExternalLink.ExternalLink, {
    link: "https://1esbot-prod.azurewebsites.net/?service=productcatalog",
    metricsTag: "RepositoryOwnerPanel.Nav1esBot",
    text: t("repositoryOwnerPanel.warning.exemptionHelp")
  })), t("repositoryOwnerPanel.warning.exemptionExplanation"));
};
exports.WarningBox = WarningBox;